
import React, { useState } from 'react';

interface AuthProps {
  onLogin: (pin: string) => void;
  isLoading: boolean;
  t: any;
  isNewUser: boolean;
}

const AuthView: React.FC<AuthProps> = ({ onLogin, isLoading, t, isNewUser }) => {
  const [pin, setPin] = useState('');

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (pin.length === 6) {
      onLogin(pin);
    }
  };

  return (
    <div className="flex-1 flex flex-col items-center justify-center p-8 bg-gray-50">
      <div className="w-20 h-20 gold-gradient rounded-3xl flex items-center justify-center shadow-lg mb-8">
        <i className="fa-solid fa-crown text-white text-4xl"></i>
      </div>
      
      <h2 className="text-2xl font-bold text-gray-800 mb-2">{t.welcome}</h2>
      <p className="text-gray-500 mb-8 text-center">{t.tagline}</p>
      
      <form onSubmit={handleSubmit} className="w-full max-w-xs flex flex-col gap-4">
        <label className="text-sm font-medium text-gray-600 text-center">
          {isNewUser ? t.setupPin : t.enterPin}
        </label>
        
        <input
          type="password"
          maxLength={6}
          pattern="\d*"
          inputMode="numeric"
          value={pin}
          onChange={(e) => setPin(e.target.value.replace(/\D/g, ''))}
          className="w-full text-center text-3xl tracking-[1rem] p-4 border rounded-2xl focus:ring-2 focus:ring-yellow-500 outline-none"
          placeholder="••••••"
          autoFocus
        />
        
        <button
          disabled={pin.length !== 6 || isLoading}
          className="w-full gold-gradient text-white font-bold py-4 rounded-2xl shadow-md active:scale-95 transition-all disabled:opacity-50"
        >
          {isLoading ? (
            <i className="fa-solid fa-spinner fa-spin"></i>
          ) : (
            t.unlock
          )}
        </button>
      </form>
    </div>
  );
};

export default AuthView;
